import {Injectable} from '@angular/core';
import {
  SynchronizationService,
  SyncMember,
  SyncOrganization,
  SyncProviderAbsence,
  SyncProviderDirectory,
  SyncProviderPresence
} from '@gt-api';
import {Observable, Subject} from 'rxjs';
import {map, startWith, tap} from 'rxjs/operators';
import {checkResponse} from '@app/shared/utils/app-utils';

@Injectable({
  providedIn: 'root'
})
export class GtSynchronizationService {
  private syncProviderSubject = new Subject<void>();
  syncProvider$ = this.syncProviderSubject.pipe(startWith(''));

  constructor(private sync: SynchronizationService) {}

  public addSyncOrganization(organization: string, login: string, syncOrg: SyncOrganization): Observable<unknown> {
    return this.sync.addSyncOrganization1(organization, login, syncOrg).pipe(checkResponse());
  }

  public addSyncProviderAbsence(organization: string, login: string, syncProviderAbsence: SyncProviderAbsence): Observable<unknown> {
    return this.sync.addSyncProvider1(organization, login, syncProviderAbsence).pipe(
      checkResponse(),
      tap(() => this.syncProviderSubject.next())
    );
  }

  public addSyncProviderDirectory(organization: string, login: string, syncProviderAbsence: SyncProviderDirectory): Observable<unknown> {
    return this.sync.addSyncProviderDirectory1(organization, login, syncProviderAbsence).pipe(
      checkResponse(),
      tap(() => this.syncProviderSubject.next())
    );
  }

  public editSyncProviderAbsence(organization: string, login: string, syncProviderAbsence: SyncProviderAbsence): Observable<unknown> {
    return this.sync.editSyncProvider1(organization, login, syncProviderAbsence).pipe(
      checkResponse(),
      tap(() => this.syncProviderSubject.next())
    );
  }

  public editSyncProviderDirectory(organization: string, login: string, syncProviderAbsence: SyncProviderDirectory): Observable<unknown> {
    return this.sync.editSyncProviderDirectory1(organization, login, syncProviderAbsence).pipe(
      checkResponse(),
      tap(() => this.syncProviderSubject.next())
    );
  }

  removeSyncProviderAbsence(organization: string, login: string, id: number): Observable<unknown> {
    return this.sync.removeSyncProviderAbsence1(id, organization, login).pipe(
      checkResponse(),
      tap(() => this.syncProviderSubject.next())
    );
  }

  removeSyncProviderDirectory(organization: string, login: string, id: number): Observable<unknown> {
    return this.sync.removeSyncProviderDirectory1(id, organization, login).pipe(
      checkResponse(),
      tap(() => this.syncProviderSubject.next())
    );
  }

  public getSyncOrganization(organization: string, login: string): Observable<SyncOrganization> {
    return this.sync.getSyncOrganization1(organization, login).pipe(
      checkResponse(),
      map(response => response.syncOrganization)
    );
  }

  public getSyncMembers(organization: string, login: string): Observable<SyncMember[]> {
    return this.sync.getSyncMembers1(organization, login).pipe(
      checkResponse(),
      map(response => response.members)
    );
  }

  public addSyncMember(organization: string, login: string, syncMember: SyncMember): Observable<unknown> {
    return this.sync.addSyncMember1(organization, login, syncMember).pipe(checkResponse());
  }

  public editSyncMember(organization: string, login: string, syncMember: SyncMember): Observable<unknown> {
    return this.sync.editSyncMember1(organization, login, syncMember).pipe(checkResponse());
  }

  public removeSyncMember(organization: string, login: string): Observable<unknown> {
    return this.sync.removeSyncMemberAbsence1(organization, login).pipe(checkResponse());
  }

  public editSyncProviderPresence(organization: string, login: string, syncProvPresence: SyncProviderPresence): Observable<unknown> {
    return this.sync.editSyncProviderPresence1(organization, login, syncProvPresence).pipe(
      checkResponse(),
      tap(() => this.syncProviderSubject.next())
    );
  }

  public addSyncProviderPresence(organization: string, login: string, syncProvPresence: SyncProviderPresence): Observable<unknown> {
    return this.sync.addSyncProviderPresence1(organization, login, syncProvPresence).pipe(
      checkResponse(),
      tap(() => this.syncProviderSubject.next())
    );
  }

  public removeSyncProviderPresence(organization: string, login: string, id: number): Observable<unknown> {
    return this.sync.removeSyncProviderPresence1(id, organization, login).pipe(
      checkResponse(),
      tap(() => this.syncProviderSubject.next())
    );
  }
}
